import { Injectable, inject } from '@angular/core';
import {ClsUtil} from '../../util/cls-util';
import {AppPresupuestosService} from './app-presupuestos.service';
import {AppInfoService} from './app-info.service';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  private infApp = inject(AppInfoService);
  private infPpto = inject(AppPresupuestosService);

  setTema() {
    let temaConfig: any = localStorage.getItem('tema') || 'light-theme';
    this.infApp.documento.documentElement.classList.add(temaConfig);
    localStorage.setItem('tema', temaConfig);
    // this.infPpto.dmPrincipal?.BusquedaGral.cambiarColorCeldaBloqueada();
    // this.cambiarTema();
  }

  cambiarTema() {
    let temaConfig: string = localStorage.getItem('tema') || 'light-theme';
    this.infApp.documento.documentElement.classList.remove(temaConfig);
    if (temaConfig === 'light-theme') {
      temaConfig = 'dark-theme';
      // this.cellStyles = this.cellDark;
    } else {
      temaConfig = 'light-theme';
      // this.cellStyles = this.cellLight;
    }
    this.infApp.documento.documentElement.classList.add(temaConfig);
    localStorage.setItem('tema', temaConfig);
    // this.infPpto.dmPrincipal?.BusquedaGral?.cambiarColorCeldaBloqueada(this.cellStyles);
    // cambiar tema viewer, diseñador no se puede hacer de esta forma, ya que se invoca de distinta manera
    // lo que se tiene que hacer es cerrar el tab del diseñador y volver abrir, en el ejemplo de Stimulsoft
    // lo que hacen es refescar la pagina
    if (!ClsUtil.esNulo(this.infPpto.dmPrincipal) && !ClsUtil.esNulo(this.infPpto.dmPrincipal.dmReportes)) {
      this.infPpto.dmPrincipal.dmReportes.vistaPrevia.cambiarTema();
      this.infPpto.dmPrincipal.dmReportes.vistaPrevia.viewer.renderHtml('viewer2');
    }
  }

}
